import { IPortfolioNavigation } from 'const';

import { SectionLoaderConfig } from './types';
import useSectionLoader from './useSectionLoader';
import useSortedSectionWidgets from './useSortedSectionWidgets';

const useCommonSectionLoader = (loaderConfig: SectionLoaderConfig, navigation: IPortfolioNavigation[]) => {
  const sectionWidgets = useSectionLoader(loaderConfig);
  const { sortedSectionWidgets, sortedNavigation } = useSortedSectionWidgets(sectionWidgets, navigation);

  const isLoading = sectionWidgets.some((data) => data.isLoading);

  return { sortedSectionWidgets, sortedNavigation, isLoading };
};

export default useCommonSectionLoader;
